import Link from "next/link";
import styles from "./index.module.scss";

export default function Menu() {
  return (
    <ul className={styles.Links}>
      <li>
        <Link href="/services/">Услуги</Link>
      </li>
      <li>
        <Link href="/faq/">Покупателям</Link>
      </li>
      <li>
        <Link href="/warranty/">Гарантия</Link>
      </li>
      <li>
        <Link href="/akczii/">Акции</Link>
      </li>
      <li>
        <Link href="/articles/">Статьи и новости</Link>
      </li>
      <li>
        <Link href="/about/">О компании</Link>
      </li>
      <li>
        <Link href="/contacts/">Контакты</Link>
      </li>
    </ul>
  );
}
